import { render, staticRenderFns } from "./EnemyActiveTooltip.vue?vue&type=template&id=5c46e10b"
import script from "./EnemyActiveTooltip.vue?vue&type=script&lang=js"
export * from "./EnemyActiveTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports